import { LeaderboardUserModel } from './LeaderboardUserModel';
import { WorkoutModel } from './WorkoutModel';
import { gradients } from '../../Constants/gradients';

export class LeaderboardModel {
    constructor(leaderboardData) {
        const currentUser = this.getCurrentUser(leaderboardData);
        const topList = this.getTopUsersList(leaderboardData);
        const workout = this.getWorkout(leaderboardData);
        const users = this.getUsers(leaderboardData);
        const gradientColor = this.getLeaderboardGradient(leaderboardData.color);

        this._leaderboard = {
            id: leaderboardData.id,
            name: leaderboardData.name,
            count: leaderboardData.count,
            color: leaderboardData.color,
            type: leaderboardData.type,
            exerciseId: leaderboardData.exercise_id,
            currentUserPlace: leaderboardData.current_user_place,
            isStarred: leaderboardData.is_starred,
            sex: leaderboardData.sex,
            age: leaderboardData.age,
            bodyweight: leaderboardData.bodyweight,
            when: leaderboardData.when,
            whenType: leaderboardData.when_type,
            city: leaderboardData.city,
            country: leaderboardData.country,
            usersCount: leaderboardData.users_count,
            gradientColor,
            currentUser,
            topList,
            workout,
            users,
        };
    }

    get leaderboard() {
        return this._leaderboard;
    }

    getCurrentUser(leaderboardData) {
        let currentUser;

        if (leaderboardData.current_user && leaderboardData.current_user.data) {
            const leaderboardUserModel = new LeaderboardUserModel(leaderboardData.current_user.data);
            return { ...leaderboardUserModel._leaderboardUser };
        }

        return currentUser;
    }

    getTopUsersList(leaderboardData) {
        let topList = [];

        if (leaderboardData.top && leaderboardData.top.data) {
            topList = leaderboardData.top.data.map(user => {
                const leaderboardUserModel = new LeaderboardUserModel(user);
                return { ...leaderboardUserModel._leaderboardUser };
            });
        }

        return topList;
    }

    getWorkout(leaderboardData) {
        let workout;

        if (leaderboardData.workout && leaderboardData.workout.data) {
            const workoutModel = new WorkoutModel(leaderboardData.workout.data);
            workout = { ...workoutModel._workout };
        }

        return workout;
    }

    getUsers(leaderboardData) {
        let users = [];

        if (leaderboardData.users) {
            users = leaderboardData.users.map(user => {
                const leaderboardUserModel = new LeaderboardUserModel(user);
                return { ...leaderboardUserModel.leaderboardUser };
            });
        }

        return users;
    }

    getLeaderboardGradient(colorIndex) {
        switch (colorIndex) {
            case 0:
                return gradients.HYPE;
            case 1:
                return gradients.AGILE;
            case 2:
                return gradients.POWER;
            case 3:
                return gradients.STRENGTH;
            case 4:
                return gradients.KETTLE;
            case 5:
                return gradients.CRUSH;
            case 6:
                return gradients.BURN;
            case 7:
                return gradients.FLEX;
            case 8:
                return gradients.GAINS;
            case 9:
                return gradients.PACE;
            default:
                return gradients.HYPE;
        }
    }
}



// WEBPACK FOOTER //
// ./src/BusinessLogic/Models/LeaderboardModel.js